module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "copyright"
    }
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("An Occupation of Angels")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Copyright © 2005, 2010 by Lavie Tidhar"), _c('br'), _vm._v("All rights reserved.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Published as an eBook in 2022 by JABberwocky Literary Agency, Inc., in association with the Zeno Agency LTD.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("Cover design © 2022 by Paul McCaffrey.")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("ISBN 978-1-625675-77-4")]), _vm._v(" "), _c('p', {
    staticClass: "crt1"
  }, [_vm._v("This book is a work of fiction. Names, characters, businesses, organizations, places and events are either the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-864f5876","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/copyright.vue
// module id = 60
// module chunks = 0